import { useGetFeaturedVideo } from './use-get-featured-video';
import { useGetShowcase } from './use-get-showcase';

export const useGetHeaderLayoutConfig = ({
  isShowcaseEmpty,
  showVideoDetails,
}: {
  isShowcaseEmpty: boolean;
  showVideoDetails: boolean;
}) => {
  const {
    title,
    thumbnailUrl,
    description,
    layout,
    isLoading: isShowcaseLoading,
  } = useGetShowcase();
  const { featuredVideo, isFeaturedOrFirstVideoLoading } = useGetFeaturedVideo();
  const defaultLayout = {
    topTitle: '',
    mainTitle: title,
    description: description || '',
    thumbnailUrl: layout === 'default' ? thumbnailUrl : '',
    isLive: false,
    showLinksInDescription: true,
  };

  if (isShowcaseLoading || isFeaturedOrFirstVideoLoading) {
    return null;
  }

  if (isShowcaseEmpty || !featuredVideo) {
    // Featured and Live layouts will have to fall back to the Default state when there are no videos
    return defaultLayout;
  }

  const featuredVideoWithVideoDetails = {
    topTitle: title,
    mainTitle: featuredVideo.name,
    description: featuredVideo.description || '',
    showLinksInDescription: false,
  };

  const featuredVideoWithShowcaseDetails = {
    topTitle: '',
    mainTitle: title,
    description: description || '',
    showLinksInDescription: true,
  };

  const featuredVideoLayout = {
    ...(showVideoDetails ? featuredVideoWithVideoDetails : featuredVideoWithShowcaseDetails),
    thumbnailUrl: featuredVideo.thumbnailUrl,
  };

  switch (layout) {
    case 'featured':
      return {
        ...featuredVideoLayout,
        isLive: false,
      };
    case 'live':
      return {
        ...featuredVideoLayout,
        // Legacy allows non-live clips to be set as `live` layout so we must check if live data actually exists to know if its live layout
        isLive: featuredVideo.isLiveClip,
      };
    default:
      return defaultLayout;
  }
};
